module.exports = __webpack_public_path__ + "static/shop-management-video-3215a1b96c1bb7b325a10cd78ad37674.png";